<template>
  <div class="group group--sidebar group--df-column">
    <div class="group group--df group--wide">
      <div>
        <h1 
          :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
          class="h1 group__title mb0">Verification Password</h1>
        <p class="p group__description">
          We have sent a verification code to {{ user.email }}. Please enter the code below to verify your account.</p>

        <transition-expand-height>
          <p v-show="resendErrorMessage" class="c-error">{{ resendErrorMessage }}</p>
          <p v-show="!resendErrorMessage && resendVerificationResponse" class="p">{{ resendVerificationResponse }}</p>
        </transition-expand-height>

        <ui-auth
          class="pab2"
          id="verify"
          :success="success"
          :send-verification="resendVerification"
          :verify-text="resendEmailCodeText"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

// Modules
import UiAuth from 'components/Auth';
import TransitionExpandHeight from 'components/ExpandHeight';

// Export
export default {
  name: 'view-register',


  // Components
  components: {
    UiAuth,
    TransitionExpandHeight,
  },


  // Data
  data() {
    return {
      resendVerificationResponse: null,
      resendEmailCodeText: 'Retry Verification',
      resendErrorMessage: null,
    };
  },


  // Computed
  computed: {
    ...mapGetters('forms', [
      'getFormView',
      'getForm',
      'getField',
    ]),
    ...mapGetters('auth', ['user']),
    ...mapGetters('app', ['org']),
    
    formId() {
      return 'confirm-sign-up';
    },

    formView() {
      return this.getFormView(this.formId);
    },
  },


  // Methods
  methods: {
    ...mapActions('auth', ['requestResendVerification']),

    resendVerification() {
      if ( this.user && this.user.email ) {
        this.resendEmailCodeText = 'Sending email code...';

        this.requestResendVerification({
          email: this.user.email,
        })
          .then(response => {
            this.resendVerificationResponse = 'Further instructions will be send to your email address';

            setTimeout(() => {
              this.resendEmailCodeText = 'Resend email code';
            }, 3000);

            return response;
          })
          .catch(error => {
            console.error(error);

            this.resendErrorMessage = error.data.errors.length > 0 && error.data.errors[0].message;

            setTimeout(() => {
              this.resendEmailCodeText = 'Resend email code';
            }, 3000);
          });
      }
    },

    success() {
      this.$router.push({
        name: 'register-success',
      });
    },
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      if ( !from.name ) {
        vm.$router.push({ name: 'home' });
      }

      next();
    });
  },
};
</script>



// WEBPACK FOOTER //
// RegisterVerification.vue?03067c44